<template>
  <v-btn-toggle 
    mandatory 
    :variant="variant" 
    v-model="language" 
    class="py-1"
  >
    <v-btn value="th" @click="changeLanguage('th')">
      <span>TH</span>
    </v-btn>
    <v-btn value="en" @click="changeLanguage('en')">
      <span>EN</span>
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      language: 'th',
    }
  },
  methods: {
    changeLanguage(lang) {
      this.language = lang
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
    }
  },
  mounted() {
    const savedLang = localStorage.getItem('lang') || this.$i18n.locale
    this.language = savedLang
    this.$i18n.locale = savedLang
  }
}
</script>
